import * as z from "zod";

import { partnerApiTokenSchema, partnerIdSchema } from "./shared";

/** Returns the plaintext secret once; only its hash is stored. */
export const createPartnerApiToken = {
  name: "createPartnerApiToken" as const,
  input: z.object({
    partnerId: partnerIdSchema,
    name: z.string().trim().min(1).max(100),
  }),
  output: z.object({ secret: z.string(), token: partnerApiTokenSchema }),
};
